export default {
  title: 'Users',
  UsersView: {
    deleteTitle: 'List of registered users to delete',
    success: 'The users were succesfully removed.'
  },
  user: {
    new: 'New',
    data: 'Enter the details of the new contact',
    add: 'Add to',
    changePass: 'Change password'
  },
  table: {
    saveNew: 'Save as new element',
    createAndSelect: 'Create and select',
    updateAndSelect: 'Update and select',
    undo: 'Undo changes',
    select: 'Select',
    noResults: 'No results found',
    username: 'User',
    userRole: 'Role',
    email: 'email',
    enabled: 'Enabled',
    disabled: 'Disabled'
  },
  searchUser: {
    title: 'Directory',
    search: 'Search in users',
    showing: 'Showing',
    username: 'Username',
    userRole: 'Role',
    email: 'Email',
    more: 'Show more',
    addSelected: 'Add selected',
    allContacts: 'All contacts',
    deleteTitle: 'Summary of selected users to delete',
    deleteConfirm: 'Are you sure you want to delete the selected users?'
  },
  button: {
    newElement: 'New User'
  },
  roles: {
    ROLE_ADMIN: 'Admin',
    ROLE_BASIC: 'Basic'
  }
}
